/* unplugin-vue-components disabled */import { render } from "./ShutdownReason.vue?vue&type=template&id=26daaf63&scoped=true&ts=true"
import script from "./ShutdownReason.vue?vue&type=script&lang=ts"
export * from "./ShutdownReason.vue?vue&type=script&lang=ts"

import "./ShutdownReason.vue?vue&type=style&index=0&id=26daaf63&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26daaf63"]])

export default __exports__